var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"candidate-placeholder relative",class:{
    interactable: _vm.interactable,
    'candidate-placeholder-small': _vm.small
  },attrs:{"draggable":"false"},on:{"click":_vm.onClick}},[(_vm.showIcon)?_c('div',{staticClass:"icon",class:{
      'icon-small': _vm.small
    }}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }